import React, { useContext, useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import HelpIcon from "@mui/icons-material/Help";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import ArticleIcon from "@mui/icons-material/Article";
import ChatIcon from "@mui/icons-material/Chat";
import Popper from "@mui/material/Popper";
import Slide from "@mui/material/Slide";
import Chip from "@mui/material/Chip";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AddCardIcon from "@mui/icons-material/AddCard";
import AIQueryComponent from "./AIQueryComponent";
import ChatComponentDropdown from "./ChatComponentDropdown_ably";
import AddDashboardPanel from "./AddDashboardPanel";
import StatusReportContainer from "./StatusReportContainer";
import Tools from "./JNSTools";
import { HelpModeContext, CredsContext } from "./Contexts";
import * as Ably from "ably";
import { AblyProvider, ChannelProvider } from "ably/react";
import "./styles/DashboardSingleProject.css";

function ProjectTitleBar(props) {
  const creds = useContext(CredsContext).creds;
  const helpMode = useContext(HelpModeContext).mode;
  const setHelpMode = useContext(HelpModeContext).setMode;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [aiAnchorElem, setAIAnchorElem] = useState(null);
  const [chatAnchorElem, setChatAnchorElem] = useState(null);
  const [openAI, setOpenAI] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const [panelsLocked, setPanelsLocked] = useState(true);
  const containerRef = useRef(null);
  const projectUrl = useRef();
  const messageCount = useRef();
  const userMentioned = useRef(null);
  const [messageFlag, setMessageFlag] = useState("caughtUp");
  const [addPanelAnchorElem, setAddPanelAnchorElem] = useState(null);
  const [showAddPanel, setShowAddPanel] = useState(false);
  /*
  THIS BLOCK REDIRECTS TO OPENAIR FOR AUTHENTICATION VIA OAUTH2
  
  useEffect(() => {
    let a = document.createElement("a");
    a.href =
      "https://top-step-sandbox.app.sandbox.openair.com/login/oauth2/v1/authorize?response_type=code&redirect_uri=https://cordtoken5.addolution.com/generate-cord-token&client_id=57248_35MgVU7gJkasfM9A&scope=xml&state=ryjp37y2qa28hdseck1gat";
    //a.target = "_blank";
    a.click();
  }, []);
  */

  //sessionStorage.setItem("panelsLocked", panelsLocked);

  const handleHelpClick = () => {
    if (helpMode) {
      document.body.style.backgroundImage = 'url("techimage2.jpg")';
    } else {
      document.body.style.backgroundImage = 'url("techimage3.jpg")';
    }
    setHelpMode(!helpMode);
  };

  const handleAIClick = (event) => {
    setAIAnchorElem(event.currentTarget);
    if (!openAI) {
      localStorage.removeItem("currentAIThreadId");
    }
    setOpenAI(!openAI);
  };

  const handleChatClick = (event) => {
    if (openChat) {
      localStorage.setItem("chatMessageCount", messageCount.current);
      userMentioned.current = null;
      setMessageFlag("caughtUp");
    } /*else {
      const ref = window.CordSDK.thread.observeThread(
        "defaultThreadProject" + projectObject.id,
        ({ messages, loading, hasMore, fetchMore, thread }) => {
          if (hasMore) {
            fetchMore(10);
          }
        },
      );
    }*/

    setChatAnchorElem(event.currentTarget);
    //if (!openChat) {
    //  localStorage.removeItem("currentAIThreadId");
    //}
    setOpenChat(!openChat);
  };

  const handleDocumentationClick = () => {
    let a = document.createElement("a");
    a.href =
      "https://collab-center-documentation.s3.us-east-1.amazonaws.com/" +
      props.docPage;
    a.target = "_blank";
    a.click();
  };

  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  /*const requestString =
    authString +
    "<MakeURL><uid></uid><page>dashboard-project</page><app>pm</app><arg><Project><id>" +
    projectObject.id +
    "</id></Project></arg></MakeURL></request>";
  Tools.fetchPost(requestString, urlString, "MakeURL").then((urlResponse) => {
    projectUrl.current = urlResponse.xml[0].textContent;
  });*/

  let chipColor = "gray";
  let chipTextColor = "white";
  if (projectObject.oada_project_health__c == "Green") {
    chipColor = "green";
  } else if (projectObject.oada_project_health__c == "Yellow") {
    chipColor = "gold";
    chipTextColor = "black";
  } else if (projectObject.oada_project_health__c == "Red") {
    chipColor = "crimson";
  }

  const healthChipObject =
    chipColor == "gray" ? null : (
      <Chip
        size="small"
        label={projectObject.oada_project_health__c}
        sx={{
          backgroundColor: [chipColor],
          color: [chipTextColor],
        }}
      />
    );

  const handleProjectNameClick = (event) => {
    if (projectUrl.current) {
      let a = document.createElement("a");
      a.href = projectUrl.current;
      a.target = "_blank";
      a.click();
    } else {
      console.log("projectUrl is not yet defined");
    }
  };

  sessionStorage.setItem("panelsLocked", panelsLocked);
  const togglePanelsLocked = (event) => {
    setAddPanelAnchorElem(event.currentTarget);
    const newLockedStatus = !panelsLocked;
    if (!panelsLocked && showAddPanel) {
      setShowAddPanel(!showAddPanel);
    }
    setPanelsLocked(newLockedStatus);
    props.setPanelsLocked(newLockedStatus);
    //handleClick(event);
  };
  const panelsLockedColor = panelsLocked ? "#643f69" : "red";
  const panelsLockedIcon = panelsLocked ? (
    <LockIcon fontSize="small"></LockIcon>
  ) : (
    <LockOpenIcon fontSize="small"></LockOpenIcon>
  );

  const handleAddPanelClick = (event) => {
    setShowAddPanel(!showAddPanel);
  };

  const handleShowStatusReport = (event) => {
    props.setStatusReportVisibility(true);
  };

  function tempAddPanel(panelId) {
    console.log("In ProjectTitleBar: " + panelId);
    props.addPanel(panelId);
  }

  return (
    <ChannelProvider channelName={creds.company}>
      <Box
        sx={{
          width: props.inDialog ? "97%" : "100%",

          backgroundColor: "gainsboro",
          color: "white",
          position: "fixed",
          top: props.topPosition,
          zIndex: 500,
        }}
      >
        <Box
          sx={{ display: "flex", justifyContent: "space-between" }}
          className="dashboardHeaderProjectNameBox"
        >
          <Box className="tour-stop-ptb1">
            {creds.userType == "regular" ? (
              <Typography variant="div" className="dashboardHeaderProjectName">
                <b>Client:</b> {projectObject.customer_name}
              </Typography>
            ) : null}
            <Typography
              variant="div"
              className="dashboardHeaderProjectName"
              onClick={handleProjectNameClick}
            >
              <b>Project:</b> {projectObject.name}&nbsp;&nbsp;&nbsp;
              {healthChipObject}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {props.docPage == "DASHBOARD TAB.pdf" ? (
              <Box display="flex">
                <Box
                  display="flex"
                  ref={containerRef}
                  sx={{
                    backgroundColor: panelsLockedColor,
                    margin: "0px",
                    borderRadius: "10px",
                    fontSize: "14px",
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  {panelsLocked ? null : (
                    <Box display="flex">
                      <IconButton
                        onClick={handleAddPanelClick}
                        size="small"
                        sx={{ color: "white", marginRight: "10px" }}
                        id="AddPanelButton"
                      >
                        <AddCardIcon />
                      </IconButton>
                    </Box>
                  )}

                  <IconButton
                    sx={{ color: "white" }}
                    onClick={togglePanelsLocked}
                    id="PanelLockToggle"
                  >
                    {panelsLockedIcon}
                  </IconButton>
                </Box>
              </Box>
            ) : null}
            <Box
              sx={{
                backgroundColor: "dimgray",
                margin: "1px",
                borderRadius: "10px",
              }}
              ref={containerRef}
            >
              <Button
                sx={{ color: "white", padding: "3px 0px 0px 5px" }}
                onClick={handleShowStatusReport}
              >
                Status
              </Button>
              <IconButton
                id="__chatButton"
                onClick={helpMode ? null : handleChatClick}
                sx={{ padding: "0px" }}
                className="tour-stop-ptb2"
              >
                <ChatIcon
                  fontSize="medium"
                  sx={{
                    paddingRight: "20px",
                    paddingLeft: "15px",
                    color:
                      messageFlag == "unread"
                        ? "blue"
                        : messageFlag == "unreadMention"
                          ? "red"
                          : "white",
                  }}
                />
              </IconButton>

              <IconButton
                id="__aiButton"
                onClick={helpMode ? null : handleAIClick}
                sx={{ padding: "0px" }}
                className="tour-stop-ptb3"
              >
                <SmartButtonIcon
                  fontSize="medium"
                  sx={{
                    paddingRight: "20px",
                    paddingBottom: "2px",
                    color: "white",
                  }}
                />
              </IconButton>
              <IconButton
                id="helpButton"
                onClick={handleHelpClick}
                sx={{ padding: "0px" }}
                className="tour-stop-ptb4"
              >
                <HelpIcon
                  fontSize="medium"
                  sx={{
                    paddingRight: "20px",
                    paddingBottom: "2px",
                    color: helpMode ? "skyblue" : "white",
                  }}
                />
              </IconButton>
              <IconButton
                id="documentationButton"
                onClick={handleDocumentationClick}
                sx={{ padding: "0px" }}
                className="tour-stop-ptb5"
              >
                <ArticleIcon
                  fontSize="medium"
                  sx={{
                    paddingRight: "15px",
                    paddingBottom: "2px",
                    color: "white",
                  }}
                />
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: 500 }}>
          <Popper
            sx={{ zIndex: 1200 }}
            open={openAI}
            anchorEl={aiAnchorElem}
            placement="bottom-end"
            transition
          >
            {({ TransitionProps }) => (
              <Slide
                {...TransitionProps}
                in={openAI}
                timeout={500}
                container={containerRef.current}
              >
                <Box>
                  <AIQueryComponent
                    queryData={props.aiData}
                    queryDataType={props.aiDataType}
                  />
                </Box>
              </Slide>
            )}
          </Popper>
        </Box>
        <Box sx={{ width: 500 }}>
          <Popper
            sx={{ zIndex: 1200 }}
            open={openChat}
            anchorEl={chatAnchorElem}
            placement="bottom-end"
            transition
          >
            {({ TransitionProps }) => (
              <Slide
                {...TransitionProps}
                in={openChat}
                timeout={500}
                container={containerRef.current}
              >
                <Box>
                  <ChatComponentDropdown />
                </Box>
              </Slide>
            )}
          </Popper>
        </Box>
        <Box sx={{ width: 500 }}>
          <Popper
            sx={{ zIndex: 1200 }}
            open={showAddPanel}
            anchorEl={addPanelAnchorElem}
            placement="bottom-end"
            transition
          >
            {({ TransitionProps }) => (
              <Slide
                {...TransitionProps}
                in={showAddPanel}
                timeout={500}
                container={containerRef.current}
              >
                <Box>
                  <AddDashboardPanel addPanel={tempAddPanel} />
                </Box>
              </Slide>
            )}
          </Popper>
        </Box>
      </Box>
    </ChannelProvider>
  );
}

export default ProjectTitleBar;

ProjectTitleBar.propTypes = {
  topPosition: PropTypes.number,
  setPanelsLocked: PropTypes.func,
  inDialog: PropTypes.bool,
  aiData: PropTypes.array,
  aiDataType: PropTypes.string,
  docPage: PropTypes.string,
  addPanel: PropTypes.func,
  setStatusReportVisibility: PropTypes.func,
};

// <Tour initialState={initialTourState} id={TOUR_ID} />
